import { Component, Input } from '@angular/core';
import { Permission, Role } from '../../../models/access.model';

export interface BusinessAccessInput {
  businessId: string;
  name?: string;
  roles: Role[];
  permissions: Permission[];
}

@Component({
  selector: 'app-business-permissions',
  standalone: false,
  templateUrl: './business-permissions.component.html',
  styleUrls: ['./business-permissions.component.css']
})
export class BusinessPermissionsComponent {
  @Input() business: BusinessAccessInput | null = null;

  selectedPermission: Permission | null = null;
  // Filter by role names (matches grantedByRoles like "BusinessOwner, Cashier")
  selectedRoleNames = new Set<string>();

  onSelectPermission(p: Permission) {
    this.selectedPermission = p;
  }

  get groupedPermissions(): Array<{ category: string; items: Permission[] }> {
    let perms = this.business?.permissions ?? [];
    // If role filter is active, filter permissions granted by selected roles
    if (this.selectedRoleNames.size > 0) {
      perms = perms.filter(p => {
        const g = (p.grantedByRoles || '').trim();
        if (!g) return false;
        const tokens = new Set(
          g.split(/[,\s]+/)
            .map(t => t.trim())
            .filter(Boolean)
            .map(t => t.toLowerCase())
        );
        for (const name of this.selectedRoleNames) {
          if (tokens.has(name.toLowerCase())) return true;
        }
        return false;
      });
    }
    const byCat = new Map<string, Permission[]>();
    for (const p of perms) {
      const cat = p.category || 'Uncategorized';
      const list = byCat.get(cat) ?? [];
      list.push(p);
      byCat.set(cat, list);
    }
    // Sort categories alphabetically; items by code
    return Array.from(byCat.entries())
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(([category, items]) => ({
        category,
        items: items.slice().sort((x, y) => (x.code || '').localeCompare(y.code || ''))
      }));
  }

  toggleRoleFilterName(roleName: string) {
    const key = (roleName || '').trim();
    if (!key) return;
    if (this.selectedRoleNames.has(key)) {
      this.selectedRoleNames.delete(key);
    } else {
      this.selectedRoleNames.add(key);
    }
  }

  clearRoleFilter() {
    this.selectedRoleNames.clear();
  }
}
